import {
  useEffect,
  useRef,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  Button,
  Box,
  Image,
  Stack,
  Text
} from '@chakra-ui/react'
import { COLORS } from 'utils/styles'
import { ImagesPng } from 'assets/images'
import {
  getComments,
  getNotificationMessage,
  likePost,
  savePost,
  setBlogLikeOngoing,
  setBlogLinkToBeCopied,
  setBlogParent,
  setBlogSaveOngoing,
  setChosenBlogIndex,
  setCloseAllDrawers,
  setCloseUserPanel,
  setComments,
  setOpenChatModal,
  setRepostThisPostData,
  setSilentPostId,
  setSharingToFriends
} from 'store'
import {
  EditIcon2,
  LikeIcon,
  CommentIcon,
  RepostIcon,
  SaveIcon,
  ShareIcon
} from 'assets/icons'
import { LoadingSpinier } from 'common/Loading'
import {
  BLOGS,
  PENDING,
  REJECTED
} from 'utils/constants'
import {
  AnimatePresence,
  motion
} from 'framer-motion'
import {
  isNotMobile,
  postTypeStatus
} from 'utils/helpers'
import { Comments } from 'components/UserSection/ProfileBlog/Comments'
import { BlogPreview } from 'components/UserSection/ProfileBlog/BlogPreview'
import { AnimatedButton } from './styled'
import { TextEditorReader } from './TextEditorReader'
import { TextAnimation } from './TextAnimation'

const MotionStack = motion(Stack)
const MotionBtn = motion(Button)

export const BlogList = ({
  blogParent,
  chosenBlogIndex,
  comments,
  commentsOption,
  fetchPosts,
  finishAnimation,
  fullName,
  getCommentsStatus,
  getPostsStatus,
  GoToMarker,
  posts,
  postCommentsStatus,
  postsTypeStatus,
  profilePicture,
  putCommentsStatus,
  selectedUser,
  setEditPostData
}) => {
  const dispatch = useDispatch()
  const [hideText, setHideText] = useState([])
  const [likeAnimate, setLikeAnimate] = useState([])
  const [saveAnimate, setSaveAnimate] = useState([])
  const [loadingMore, setLoadingMore] = useState(false)
  const [oldPostsCount, setOldPostsCount] = useState(0)
  const observer = useRef()
  const secondToLastItem = useRef(null)

  const animateLike = (id) => {
    setLikeAnimate((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }))

    setTimeout(() => {
      setLikeAnimate((prevState) => ({
        ...prevState,
        [id]: !prevState[id]
      }))
    }, 500)
  }

  const animateSave = (id) => {
    setSaveAnimate((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }))

    setTimeout(() => {
      setSaveAnimate((prevState) => ({
        ...prevState,
        [id]: !prevState[id]
      }))
    }, 500)
  }

  const hideTextMap = (id) => {
    setHideText((prevState) => ({
      ...prevState,
      [id]: !prevState[id]
    }))
  }

  const colorDirection = () => {
    console.log()
    return isNotMobile()
      ? COLORS.lightGoldGradientRightToLeft
      : COLORS.lightGoldGradientLeftToRight
  }

  const startEditPost = (item) => {
    if (postsTypeStatus !== 'archived') {
      dispatch(setSilentPostId(item?.postDraftId))
    }

    setEditPostData({})
    setEditPostData(item)
  }

  const goToHeaderOriginalPos = (index) => {
    const drawer = document.querySelector(`#${BLOGS}-drawer-body`)
    const targetElement = document.querySelector('#blogStartItem' + index)

    if (drawer && targetElement) {
      const containerTop = drawer.getBoundingClientRect().top
      const elementTop = targetElement.getBoundingClientRect().top
      const scrollDifference = Math.floor(elementTop) - containerTop

      drawer.scrollTop += scrollDifference
    }
  }

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      // The "10" is the limit set on the backend DB query
      if (entries[0].isIntersecting && posts.length - oldPostsCount >= 10) {
        observer.current.unobserve(secondToLastItem.current)
        setLoadingMore(true)
        setOldPostsCount(posts.length)
        fetchPosts(
          posts.at(-1).id,
          posts.at(-1).created_at
        )
      }
    })

    const currentObserver = observer.current
    if (secondToLastItem.current && posts.length - oldPostsCount >= 10) {
      currentObserver.observe(secondToLastItem.current)
    }

    setLoadingMore(false)

    return () => {
      if (secondToLastItem.current) {
        observer.current.disconnect()
      }
    }
  }, [posts])

  const filteredPosts = posts.filter((item) => {
    if (
      (
        postsTypeStatus === 'scheduled'
        && postTypeStatus({ item, getCategOnly: true }).includes('Scheduled')
      )
      || (
        postsTypeStatus === 'posted'
        && (
          postTypeStatus({ item, getCategOnly: true }).includes('Published')
          || postTypeStatus({ item, getCategOnly: true }).includes('Modified')
        )
      )
      || (
        postsTypeStatus === 'archived'
        && postTypeStatus({ item, getCategOnly: true }).includes('Archived')
      )
    ) {
      return true
    }

    return false
  })

  return (
    <Stack
      margin={
        blogParent.length
          ? '-24px 0'
          : '16px 0'
      }
      gap="0 !important"
      maxHeight="80vh"
      height="100%"
    >
      {
        getPostsStatus === PENDING && !posts.length
          ? (
            <Stack marginTop="100px">
              <LoadingSpinier />
            </Stack>
          ) : ''
      }
      {
        filteredPosts && filteredPosts.length
          ? filteredPosts.map((item, index) => {
            const imagesAreLoaded = (
              item.imageLoaded >= item.imageCount
                || !item?.imageCount
            )
            && (
              !item?.repost_post_id
              || !Object.keys(item?.repostPostData).length
              || item?.repostPostData?.imageLoaded >= item?.repostPostData?.imageCount
              || !item?.repostPostData?.imageCount === 0
            )

            return (
              <Stack
                id={'blogStartItem' + index}
                ref={posts.length - 2 === index ? secondToLastItem : null}
                width="calc(100% + 130px)"
                border="solid 1px black"
                borderTop="none"
                borderBottom={posts.length - 1 === index ? 'auto' : 'none'}
                background={COLORS.whiteGrayGradientBotToTop}
                padding="10px"
                display={
                  !blogParent.length || blogParent[0]?.id === item?.id
                    ? 'flex'
                    : 'none'
                }
                justifyContent="flex-start"
                gap="1rem"
                marginLeft="-65px"
                pos="relative"
                zIndex={1000 - index}
              >
                <Stack
                  id={'stickyHeader' + item?.id}
                  position="sticky"
                  top="0"
                  zIndex="5"
                  margin="-10px"
                  padding="10px 5px"
                  backgroundColor={COLORS.white}
                  borderTop="solid 1px black"
                  boxShadow="0 4px 10px rgba(0, 0, 0, 0.2)"
                  _hover={{
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)'
                  }}
                >
                  {
                    imagesAreLoaded
                      ? (
                        <Stack
                          width="15px"
                          height="15px"
                          right="3"
                          pos="absolute"
                          pointerEvents={blogParent.length ? 'none' : 'auto'}
                          cursor={blogParent.length ? 'default' : 'pointer'}
                          opacity={blogParent.length ? 0 : 1}
                          onClick={() => {
                            startEditPost(item)

                            if (item?.repost_post_id) {
                              dispatch(setRepostThisPostData(item?.repostPostData))
                            }
                          }}
                        >
                          <EditIcon2 />
                        </Stack>
                      ) : (
                        <Stack
                          width="15px"
                          height="15px"
                          cursor="default"
                          right="3"
                          pos="absolute"
                        >
                          <LoadingSpinier width="15px" height="15px" />
                        </Stack>
                      )
                  }
                  <Stack
                    alignItems="center"
                    display="inline"
                    width="auto"
                    justifyContent="flex-start"
                  >
                    <Image
                      boxSize="55px"
                      position="relative"
                      objectFit="cover"
                      src={
                        (
                          blogParent.length > 1
                            ? blogParent?.at(-1)?.profile_picture
                            : profilePicture
                        )
                        ?? ImagesPng.DefaultImage
                      }
                      alt="User Image"
                      borderRadius="full"
                      display="inline-flex"
                      verticalAlign="bottom"
                      cursor={item.coordinates && item.coordinates.length ? 'pointer' : 'auto'}
                      onClick={() => {
                        if (
                          item.coordinates
                          && item.coordinates.length
                        ) {
                          GoToMarker(blogParent.length > 1 ? blogParent.at(-1) : item)
                        }
                      }}
                    />
                    <Text
                      display="inline-flex"
                      marginLeft="10px"
                      fontSize="16px"
                      lineHeight="28px"
                      wordBreak="break-word"
                    >
                      <Box display="contents">
                        {
                          blogParent.length > 1
                            ? blogParent.at(-1)?.full_name
                            : fullName
                        }
                      </Box>
                      <br />
                      <Box
                        display="contents"
                        letterSpacing="-1px"
                      >
                        {
                          postTypeStatus({
                            item: blogParent.length > 1 ? blogParent.at(-1) : item,
                            noLabel: true
                          })
                        }
                      </Box>
                    </Text>
                  </Stack>

                  <Stack
                    display="flex"
                    justifyContent="center"
                    direction="row"
                  >
                    <MotionBtn
                      initial={{
                        background: hideText[item.id]
                          ? colorDirection()
                          : COLORS.darkGrayGradientBotToTop
                      }}
                      animate={{
                        background: hideText[item.id]
                          ? COLORS.darkGrayGradientBotToTop
                          : colorDirection()
                      }}
                      whileTap={{ scale: 0.95 }}
                      padding="2px 0"
                      fontSize="19px"
                      width="100%"
                      borderRadius="5px"
                      align="center"
                      letterSpacing=".15px"
                      fontWeight="400"
                      _hover={{
                        background: ''
                      }}
                      _active={{
                        background: ''
                      }}
                      onClick={() => {
                        goToHeaderOriginalPos(index)
                        hideTextMap(item.id)
                      }}
                      pointerEvents={
                        blogParent.length
                          ? 'none'
                          : 'auto'
                      }
                      display="block"
                      overflow="hidden"
                    >
                      <TextAnimation
                        item={item}
                        blogParent={blogParent}
                        place="profile-panel"
                        finishAnimation={finishAnimation}
                      />
                    </MotionBtn>
                  </Stack>

                  <MotionStack
                    initial={{ x: 0 }}
                    animate={{
                      height: hideText[item.id] ? '0px' : 'auto',
                      opacity: hideText[item.id] ? '0' : '1'
                    }}
                    transition={{
                      type: 'spring',
                      stiffness: 300,
                      damping: 60
                    }}
                    direction="row"
                    justifyContent="center"
                    margin="-2.5px 0"
                    display={blogParent.length > 1 ? 'none' : 'flex'}
                  >
                    {
                      item.affinities.length
                        ? item.affinities.map((e) => (
                          <Box
                            color="#F8F8FF"
                            border="solid 1px black"
                            borderRadius="5px"
                            bg={COLORS.gold}
                            p="0 2px"
                            data-name="blog-affinity"
                            fontSize="11px"
                            margin="2.5px 0"
                            overflow="hidden"
                          >
                            {e.title}
                          </Box>
                        ))
                        : (
                          <Box
                            color="#F8F8FF"
                            border="solid 1px black"
                            borderRadius="5px"
                            bg={COLORS.gold}
                            p="0 2px"
                            data-name="blog-affinity"
                            fontSize="11px"
                            overflow="hidden"
                          >
                            No Affinities
                          </Box>
                        )
                    }
                  </MotionStack>
                </Stack>

                <Box
                  className="article-body"
                  display="grid"
                  sx={{
                    '& > *': {
                      gridArea: '1 / 1',
                      minWidth: 0,
                      objectFit: 'contain'
                    }
                  }}
                >
                  <AnimatePresence mode="sync">
                    {
                      blogParent.length
                      && blogParent[0].id === item.id
                        ? (
                          <MotionStack
                            key="comment-section"
                            initial={{ x: -450 }}
                            animate={{ x: 0 }}
                            exit={{ x: -450 }}
                            transition={{
                              type: 'tween',
                              duration: 0.8
                            }}
                            width="100%"
                            zIndex={2}
                            transformOrigin="top"
                          >
                            <Comments
                              blogParent={blogParent}
                              commentsOption={commentsOption}
                              comments={comments}
                              getCommentsStatus={getCommentsStatus}
                              postCommentsStatus={postCommentsStatus}
                              putCommentsStatus={putCommentsStatus}
                              selectedUser={selectedUser}
                            />
                          </MotionStack>
                        ) : ''
                    }
                    <MotionStack
                      width="calc(100% + 20px)"
                      marginLeft="-10px"
                      marginBottom="-10px"
                      padding="0 5px 15px 5px"
                      initial={{ height: 'auto' }}
                      animate={{ height: blogParent.length && blogParent[0].id === item.id ? 0 : 'auto', display: 'flex' }}
                      exit={{ height: blogParent.length && blogParent[0].id === item.id ? 'auto' : 0, display: 'grid' }}
                      transition={{
                        delay: blogParent.length && blogParent[0].id === item.id ? 0.8 : 0
                      }}
                      display={blogParent.length && blogParent[0].id ? 'flex' : 'grid'}
                    >
                      <MotionStack
                        initial={{ x: 0 }}
                        animate={{ height: hideText[item.id] ? '0px' : 'auto' }}
                        transition={{
                          type: 'spring',
                          stiffness: 300,
                          damping: 60
                        }}
                        width="100%"
                        display="block"
                        overflow="hidden"
                      >
                        <TextEditorReader
                          dispatch={dispatch}
                          item={item}
                          setCloseAllDrawers={setCloseAllDrawers}
                        />

                        {
                          item?.has_repost
                            ? (
                              <BlogPreview
                                from="blogListFromUserPanel"
                                item={item?.repostPostData}
                                blogParent={blogParent}
                                GoToMarker={GoToMarker}
                                finishAnimation={finishAnimation}
                              />
                            ) : ''
                        }
                      </MotionStack>

                      <Stack
                        width="100%"
                        marginLeft="0px"
                        height="29px"
                        direction="row"
                        border="solid 1px black"
                        borderRadius="5px"
                        padding="1.5px 15px"
                        justifyContent="space-around"
                        background={COLORS.whiteYellowGradientTopToBot}
                        gap="0"
                      >
                        <AnimatedButton className={likeAnimate[item.id] ? 'animate' : ''}>
                          <Stack
                            as="button"
                            onClick={() => {
                              if (!item?.likeOngoing) {
                                animateLike(item.id)
                                dispatch(setBlogLikeOngoing({
                                  id: item.id,
                                  type: 'post'
                                }))
                                dispatch(likePost(item.id))
                              }
                            }}
                          >
                            <LikeIcon fill={item.likedByMe ? COLORS.gold : 'none'} />
                          </Stack>

                          <Text>{item.likes}</Text>
                        </AnimatedButton>

                        <Stack
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                        >
                          <Stack
                            as="button"
                            onClick={() => {
                              if (blogParent.length && chosenBlogIndex >= 0) {
                                goToHeaderOriginalPos(chosenBlogIndex)

                                dispatch(
                                  getNotificationMessage({
                                    type: REJECTED,
                                    message: 'A comment section is still open',
                                    isEditProfile: true
                                  })
                                )
                              } else {
                                dispatch(setChosenBlogIndex(index))
                                goToHeaderOriginalPos(index)

                                dispatch(setComments([]))
                                dispatch(setBlogParent([item]))
                                dispatch(getComments({
                                  type: 'post',
                                  post_id: item.id
                                }))
                              }
                            }}
                          >
                            <CommentIcon />
                          </Stack>
                          <Text>{item.comments}</Text>
                        </Stack>

                        <Stack
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                          cursor={imagesAreLoaded ? 'auto' : 'not-allowed'}
                        >
                          <Stack
                            pointerEvents={imagesAreLoaded ? 'auto' : 'none'}
                            onClick={() => dispatch(setRepostThisPostData(item))}
                          >
                            <RepostIcon />
                          </Stack>
                          <Text>{item?.reposts}</Text>
                        </Stack>

                        <Stack
                          display="flex"
                          flexDirection="row"
                          alignItems="center"
                        >
                          <Stack
                            as="button"
                            onClick={() => {
                              const modalUserDrawer = document.querySelector('#chakra-modal-user-drawer')

                              if (
                                modalUserDrawer
                                && modalUserDrawer.offsetWidth * 2.2 >= document.querySelector('body').offsetWidth
                              ) {
                                dispatch(setCloseUserPanel(true))
                                setTimeout(() => dispatch(setCloseUserPanel(false)), 300)
                              }

                              dispatch(setOpenChatModal(true))
                              dispatch(setSharingToFriends(true))
                              dispatch(setBlogLinkToBeCopied(window.location.origin + '/?post-id=' + item?.id))
                              sessionStorage.setItem('isSharingBlog', 'true')
                              window.dispatchEvent(new CustomEvent('isSharingBlog-changed'))
                              setTimeout(() => dispatch(setOpenChatModal(false)), 300)
                            }}
                          >
                            <ShareIcon />
                          </Stack>
                          <Text>{item.shares}</Text>
                        </Stack>

                        <AnimatedButton className={saveAnimate[item.id] ? 'animate' : ''}>
                          <Stack
                            as="button"
                            onClick={() => {
                              if (!item?.saveOngoing) {
                                animateSave(item.id)
                                dispatch(setBlogSaveOngoing(item.id))
                                dispatch(savePost(item.id))
                              }
                            }}
                          >
                            <SaveIcon
                              width="18"
                              height="18"
                              viewBox="0 2 22 22"
                              fill={item.savedByMe ? COLORS.gold : 'none'}
                            />
                          </Stack>
                          <Text>{item.saves}</Text>
                        </AnimatedButton>
                      </Stack>
                    </MotionStack>
                  </AnimatePresence>
                </Box>
              </Stack>
            )
          })
          : (
            <Stack>
              {
                getPostsStatus === PENDING && !posts.length
                  ? ''
                  : (
                    <Text
                      textAlign="center"
                      width="calc(100% + 112px)"
                      backgroundColor="rgb(229, 229, 229)"
                      borderRadius="3px"
                      border="solid 1px black"
                      padding="10px"
                      margin="0 0 0 -56px !important"
                    >
                      Click the "Create" button to create a post
                    </Text>
                  )
              }
            </Stack>
          )
      }
      {
        loadingMore && getPostsStatus === PENDING
          ? (
            <Stack margin="75px 0 50px 0">
              <LoadingSpinier />
            </Stack>
          ) : ''
      }
    </Stack>
  )
}
